import React from 'react'
import Chart from 'chart.js'
import { Radar, Doughnut } from 'react-chartjs'
import MiddleLine from '../../img/icons/general-icons/separator_icon_gray.png'

export default class DashboardCharts extends React.Component {
  render () {
    var data1 = {
      labels: ['Riesgo subclínico', 'Vigor', 'METs', 'Balance afectivo', 'Satisfacción'],
      datasets: [
        {
          label: 'Calculo',
          fillColor: 'rgba(198, 31, 40, 0.4)',
          strokeColor: 'rgba(198, 31, 40, 0.8)',
          highlightFill: 'rgba(198, 31, 40, 0.5)',
          highlightStroke: 'rgba(198, 31, 40, 0.8)',
          data: this.props.data.chart1
        }
      ]
    }

    var data2 = {
      labels: ['Arterial', 'Metabólica', 'Cardiopulmonar', 'Bienestar', 'Vigor'],
      datasets: [
        {
          label: 'Calculo',
          fillColor: 'rgba(30, 124, 144, 0.4)',
          strokeColor: 'rgba(30, 124, 144, 0.8)',
          highlightFill: 'rgba(30, 124, 144, 0.5)',
          highlightStroke: 'rgba(30, 124, 144, 0.8)',
          data: this.props.data.chart2
        }
      ]
    }

    var data3 = [{
      value: this.props.data.fx_reserve.toFixed(1),
      color: 'rgba(	0, 142, 39, 0.5)',
      label: 'Reserva funcional'
    }, {
      value: this.props.data.percent_lost_capacity.toFixed(1),
      color: 'rgba(198, 31, 40, 0.5)',
      label: 'Capacidad perdida'
    }]

    var chartOptions = {
      pointLabelFontSize: 12, scaleShowLabels: true,
      scaleStartValue: 0, scaleOverride: true,
      pointLabelFontColor: '#000', scaleSteps: 5, scaleStepWidth: 2,
      scaleFontColor: '#000', scaleLineColor: '#000',
      angleLineColor: 'rgba(255,255,255,0.5)', responsive: true,
      scaleBackdropColor: 'rgba(255,255,255,0.75)'
    }

    var doughnutOptions = {
      segmentShowStroke: true, animateRotate: true,
      animateScale: false, percentageInnerCutout: 50, responsive: true,
      tooltipTemplate: '<%= value %>%'
    }

    let arterialAge = this.props.data.arterialAge.toFixed(1)
    let biologicalAge = this.props.data.biologicalAge.toFixed(1)
    arterialAge = arterialAge >85 ? 85 : arterialAge;
    biologicalAge = biologicalAge > 85 ? 85 : biologicalAge;
    return (
      <div className='chart-section-printable'>
        <div className='chart-printable2'>
          <div className='header-printable'>
            <div className='section-title'>Indice de Capacidad Funcional: {this.props.data.functionalIndex.toFixed(1)}</div>
          </div>
          <img className='chart chart-radar' width='320' src={this.props.img2}/>
          <Radar id="uniqueRadar" data={data2} className='chart chart-radar' options={chartOptions} redraw />
          <span className='dataAge'>{arterialAge}</span>
        </div>
        <img className='middleline_printable2' src={MiddleLine} />
        <div className='chart-printable2'>
          <div className='header-printable'>
            <div className='section-title'>Reserva Funcional: {this.props.data.fx_reserve.toFixed(1)}%</div>
          </div>
          <img className='chart chart-doughnut' width='320' src={this.props.img}/>
          <Doughnut data={data3} id='myChart' className='chart chart-doughnut' options={doughnutOptions} redraw/>
          
          <span className='dataAge'>{biologicalAge}</span>
        </div>
      </div>
    )
  }
}

DashboardCharts.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/DashboardChartComponent.js